import { render, staticRenderFns } from "./supervisedEntityDeactivatedNotificationItem.vue?vue&type=template&id=65f4e3a2"
import script from "./supervisedEntityDeactivatedNotificationItem.vue?vue&type=script&lang=ts"
export * from "./supervisedEntityDeactivatedNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports